module.exports = __webpack_public_path__ + "static/media/logo.bbc85b54.png";